export const load = () => ({
	title: 'Effects of Noise Pollution on Human Health',
	showTitle: true,
});
